import { Broadcaster } from '@cordic/broadcaster';

export class ChatBroadcaster extends Broadcaster {
  constructor()
  {
    super();
    window['broadcaster'] = this;
  }
}
